import { Star, ArrowUpRight } from "lucide-react";
import avatarStack from "../../../img/renaissance-new/stories/pfp.webp";
import { IMPACT_COLUMN_1, IMPACT_COLUMN_2, IMPACT_COLUMN_3, IMPACT_MOBILE, IMPACT_VIDEOS } from "./impactSectionData";
import TestimonialCard from "./testimonialCard";
import VideoCard from "./videoCard";

const renderColumn = (items) =>
    items.map((item, i) =>
        item.type === "video" ? (
            <VideoCard key={i} thumbnail={item.thumbnail} videoUrl={item.videoUrl} />
        ) : (
            <TestimonialCard key={i} {...item} />
        ),
    );

const ImpactSection = () => {
    return (
        <div className="flex flex-col items-center bg-[#F8FAFC] sm:py-20 sm:px-10 py-[60px] px-5 gap-10">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6 w-full max-w-[1120px]">
                <div className="flex flex-col gap-2 flex-1">
                    <div className="text-[24px] leading-[30px] sm:text-[40px] sm:leading-[64px] tracking-[0.02em] sm:tracking-[0.04em] text-[#020617] font-gilroy-bold">
                        They did it, so can you!
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-[126px] sm:w-[168px] h-12 overflow-hidden shrink-0">
                            <img src={avatarStack} alt="" className="w-[168px] h-12 max-w-none object-cover object-left" />
                        </div>
                        <div className="flex flex-col gap-1">
                            <div className="flex items-center gap-2">
                                <div className="flex items-center gap-0.5">
                                    {Array.from({ length: 5 }).map((_, i) => (
                                        <Star
                                            key={i}
                                            size={16}
                                            className="text-[#FBBF24] fill-[#FBBF24]"
                                        />
                                    ))}
                                </div>
                                <span className="font-gilroy-semibold text-[14px] leading-[14px] tracking-[0.02em] text-[#020617]">
                                    4.9/5
                                </span>
                            </div>
                            <span className="font-gilroy-semibold text-[14px] leading-4 tracking-[0.02em] text-[#020617]">
                                Trusted by 20000+ Students
                            </span>
                        </div>
                    </div>
                </div>
                <a
                    href="/crack-coding-interviews/stories"
                    className="hidden sm:flex items-center justify-center gap-1 shrink-0 px-8 py-3 h-12 bg-[#020617] rounded-xl font-gilroy-bold text-[16px] leading-6 tracking-[0.02em] text-white"
                >
                    Read More Stories
                    <ArrowUpRight size={20} />
                </a>
            </div>

            {/* Mobile: peek-scroll video carousel, then a shorter curated quote list */}
            <div className="no-scrollbar flex sm:hidden gap-3 w-full max-w-[1120px] overflow-x-auto snap-x snap-mandatory -mx-5 px-5">
                {IMPACT_VIDEOS.map((item, i) => (
                    <div key={i} className="shrink-0 w-[85%] snap-start">
                        <VideoCard thumbnail={item.thumbnail} videoUrl={item.videoUrl} />
                    </div>
                ))}
            </div>

            <div className="flex sm:hidden flex-col gap-3 w-full max-w-[1120px]">
                {IMPACT_MOBILE.map((item, i) => (
                    <TestimonialCard key={i} {...item} />
                ))}
            </div>

            <div className="hidden sm:flex flex-row items-start gap-6 w-full max-w-[1120px]">
                <div className="flex flex-col gap-6 w-full sm:flex-1">
                    {renderColumn(IMPACT_COLUMN_1)}
                </div>
                <div className="flex flex-col gap-6 w-full sm:flex-1">
                    {renderColumn(IMPACT_COLUMN_2)}
                </div>
                <div className="flex flex-col gap-6 w-full sm:flex-1">
                    {renderColumn(IMPACT_COLUMN_3)}
                </div>
            </div>

            <a
                href="/crack-coding-interviews/stories"
                className="flex sm:hidden items-center justify-center gap-1 shrink-0 px-8 py-3 h-12 bg-[#020617] rounded-xl font-gilroy-bold text-[16px] leading-6 tracking-[0.02em] text-white"
            >
                Read More Stories
                <ArrowUpRight size={20} />
            </a>
        </div>
    );
};

export default ImpactSection;
